var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendorWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.98008 14H13.0201C14.0467 14 14.6867 12.8866 14.1734 12L9.15341 3.32662C8.64008 2.43995 7.36008 2.43995 6.84674 3.32662L1.82674 12C1.31341 12.8866 1.95341 14 2.98008 14ZM8.00008 9.33329C7.63341 9.33329 7.33341 9.03329 7.33341 8.66662V7.33329C7.33341 6.96662 7.63341 6.66662 8.00008 6.66662C8.36674 6.66662 8.66674 6.96662 8.66674 7.33329V8.66662C8.66674 9.03329 8.36674 9.33329 8.00008 9.33329ZM8.66674 12H7.33341V10.6666H8.66674V12Z",
    fill: "#FF5449"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorWarning);
export default __webpack_public_path__ + "static/media/Vendor-warning.ab0458cba8bd52528406beeb27d5f305.svg";
export { ForwardRef as ReactComponent };